import * as logger from 'loglevel';
import transformRequestFlightRecommendations from './transformRequest/transformRecommendations';
import axiosWrapper from '../../helpers/axiosWrapper';

/**
 * Transform data from Fare AI API
 * @param {*} param0
 * @returns
 */
const transformData = ({ params: rawResponse }) => {
  if (rawResponse) {
    // Sorting the values of the keys so that if they return the same values, the request can be cached
    if (Array.isArray(rawResponse.origins)) {
      rawResponse.origins.sort();
    }
    if (Array.isArray(rawResponse.destinations)) {
      rawResponse.destinations.sort();
    }
  }
  return rawResponse;
};

const validateRecommendations = (rawResponse) => {
  const validation = { isValid: true, message: '' };
  if (rawResponse && !rawResponse?.result && !rawResponse?.result.params) {
    validation.isValid = false;
    validation.message =
      'INTEGRATION__RECOMMENDATIONS: Response request SCHEMA is invalid, please check Fares AI API documentation.';
  }
  return validation;
};
const getRecommendations = (filter, integrationSettings, meta, pageContext) => {
  return new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings** not especified.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    const { v1FlightRecommendation } = integrationSettings;

    let filterCopy = { ...filter };

    if (
      !v1FlightRecommendation ||
      !v1FlightRecommendation.method ||
      !v1FlightRecommendation.endPoint ||
      !v1FlightRecommendation.headers
    ) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings.v1FlightRecommendation** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }

    axiosWrapper(
      {
        method: v1FlightRecommendation.method,
        url: `${v1FlightRecommendation.endPoint}`,
        headers: { ...v1FlightRecommendation.headers },
        data: transformRequestFlightRecommendations(filterCopy)
      },
      {
        resource: 'INTEGRATION__FLIGHTS__RECOMMENDATIONS',
        meta,
        integrationSettings,
        pageContext,
        cache: v1FlightRecommendation?.cache,
        cacheDuration: v1FlightRecommendation?.cacheDuration
      }
    )
      .then((response) => {
        logger.info('INTEGRATION__FLIGHTS__RECOMMENDATIONS: Successful request', response.data);
        const validation = validateRecommendations(response.data);
        if (validation.isValid) {
          const payload = transformData(response?.data?.result);
          const newPayload = {
            ...payload
          };
          newPayload.explanation = payload?.explanation;
          resolve(newPayload);
        } else {
          logger.error(validation.message, validation.data);
        }
      })
      .catch((err) => {
        logger.error(err);
        reject(err);
      });
  });
};

export { getRecommendations };
